import { lazy } from 'react'
import type { RouteWithMeta } from '../types'
import { withSuspense } from '../utils/withSuspense'

// Lazy loading으로 성능 최적화
const SettlementPage = lazy(() => import('@/pages/settlement/temporary/page'))
const SettlementSalesHistoryPage = lazy(() => import('@/pages/settlement/temporary/SettlementSalesHistoryPage'))
const SettlementExcelHistoryPage = lazy(() => import('@/pages/settlement/temporary/SettlementExcelHistoryPage'))

/**
 * 정산 라우트
 * - 정산 총괄 조회
 * - 전체 판매 내역
 * - 추출 이력
 */
export const settlementRoutes: RouteWithMeta = {
  path: 'settlements',
  meta: {
    label: '정산',
    showInMenu: true,
    icon: ''
  },
  children: [
    // TODO. 후에 실제로 사용할 정산 데이터
    // {
    //   path: 'policy',
    //   element: withSuspense(<SettlementPolicyPage/>),
    //   meta: {
    //     label: '정산 정책 관리',
    //     showInMenu: true,
    //   }
    // },
    // ===== 정산 총괄 조회 =====
    {
      path: 'settlement',
      element: withSuspense(<SettlementPage/>),
      meta: {
        label: '정산 총괄 조회',
        showInMenu: true,
      }
    },
    // ===== 전체 판매 내역 =====
    {
      path: 'settlement-sales-history',
      element: withSuspense(<SettlementSalesHistoryPage/>),
      meta: {
        label: '전체 판매 내역',
        showInMenu: true,
      }
    },
    // ===== 추출 이력 =====
    {
      path: 'settlement-history',
      element: withSuspense(<SettlementExcelHistoryPage/>),
      meta: {
        label: '추출 이력',
        showInMenu: true,
      }
    },
  ]
}
